import { library } from '@fortawesome/fontawesome-svg-core'

import { faBooks } from '@fortawesome/pro-solid-svg-icons/faBooks'
import { faBoxOpen } from '@fortawesome/pro-solid-svg-icons/faBoxOpen'
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus'
import { faStar } from '@fortawesome/pro-solid-svg-icons/faStar'
import { faSearch } from '@fortawesome/pro-solid-svg-icons/faSearch'
import { faMousePointer } from '@fortawesome/pro-solid-svg-icons/faMousePointer'
import { faDownload } from '@fortawesome/pro-solid-svg-icons/faDownload'
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash'
import { faPencil } from '@fortawesome/pro-solid-svg-icons/faPencil'
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes'
import { faExpandAlt } from '@fortawesome/pro-solid-svg-icons/faExpandAlt'
import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons/faSpinnerThird'
import { faWindowAlt } from '@fortawesome/pro-duotone-svg-icons/faWindowAlt'
import { faArrowsAltV } from '@fortawesome/pro-regular-svg-icons/faArrowsAltV'
import { faTimes as farTimes } from '@fortawesome/pro-regular-svg-icons/faTimes'
import { faStar as falStar } from '@fortawesome/pro-light-svg-icons/faStar'
import { faList } from '@fortawesome/pro-solid-svg-icons/faList'
import { faShoppingCart } from '@fortawesome/pro-solid-svg-icons/faShoppingCart'
import { faTruckContainer } from '@fortawesome/pro-solid-svg-icons/faTruckContainer'
import { faMinus } from '@fortawesome/pro-solid-svg-icons/faMinus'
import { faClone } from '@fortawesome/pro-solid-svg-icons/faClone'

library.add(
  faBooks, faBoxOpen, faPlus, faStar, faSearch, faMousePointer, faDownload, faTrash, faPencil, faTrash,
  faTimes, faExpandAlt, faSpinnerThird, faWindowAlt, faArrowsAltV, farTimes, falStar, faList, faShoppingCart,
  faTruckContainer, faMinus, faClone
)
